import { render, staticRenderFns } from "./IComments.vue?vue&type=template&id=c9f32e56&scoped=true&"
import script from "./IComments.vue?vue&type=script&lang=js&"
export * from "./IComments.vue?vue&type=script&lang=js&"
import style0 from "./IComments.vue?vue&type=style&index=0&id=c9f32e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f32e56",
  null
  
)

export default component.exports